import { render, staticRenderFns } from "./IvmConsumptionApi.vue?vue&type=template&id=524bcdf8&lang=pug&"
import script from "./IvmConsumptionApi.vue?vue&type=script&lang=ts&"
export * from "./IvmConsumptionApi.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports